// @ts-nocheck
import React from 'react'
import { useI18n } from '../../i18n/I18nContext'


const Title = ({ placeholder, label, required }) => {

    const { t } = useI18n();


    return (
        <>
            <div className="mb-8 border-b border-slate-100 pb-5 text-left">
                <header className="leading-tight">
                    <div data-i18n-ignore="true" className="mb-1 text-2xl font-bold tracking-tight text-slate-950 sm:text-3xl">{label}</div>
                    <div className="text-sm font-normal leading-6 text-slate-500">{t(placeholder)}</div>
                </header>
            </div>
        </>
    )
}

export default Title
